export default {"src":"/_next/static/media/medical-team.1ef35faf.svg","height":81,"width":90,"blurWidth":0,"blurHeight":0};